<template>
  <b-modal ref="modal" hide-footer centered title="Import Excel file">
    <b-form @submit.prevent="importExcel">
      <b-form-group>
        <b-form-file
          v-model="$v.excelFile.$model"
          class="custom-file-input"
          :class="{ 'is-invalid': $v.excelFile.$error }"
          placeholder="Choose a file..."
          :disabled="inProcess"
          style="opacity: 1;"
        />
        <b-form-invalid-feedback v-if="!$v.excelFile.required">Excel file is required</b-form-invalid-feedback>
      </b-form-group>
      <b-button variant="success" type="submit" :disabled="inProcess">
        <b-spinner v-if="inProcess" small style="vertical-align: -2px;"></b-spinner>
        <span v-if="!inProcess">Import</span>
        <span v-else>Importing...</span>
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import config from '@/config'
// service
import auth from '@/services/auth'

export default {
  props: ['gridId'],
  data() {
    return {
      excelFile: null,
      inProcess: false,
    }
  },
  computed: {
    ...mapState(['currentDash']),
  },
  methods: {
    open() {
      if (this.$refs.modal) this.$refs.modal.show()
    },
    close() {
      if (this.$refs.modal) this.$refs.modal.hide()
    },
    async importExcel() {
      if (this.inProcess) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.inProcess = true

      const functionsUrl = config.midServer[process.env.APP_CONF.instance]
      const authToken = await auth.getIdToken()

      this.$axios
        .post(
          `${functionsUrl}/dataGrid_importExcel?dashId=${
            this.currentDash
          }&gridId=${encodeURI(this.gridId)}&authToken=${encodeURI(authToken)}`,
          this.excelFile,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )
        .then((res) => {
          if (res.data.status === 'OK') {
            this.$popupRes({
              title: 'Success!',
              message: `Import completed.`,
              variant: 'success',
            })

            this.inProcess = false
            this.excelFile = null
            this.close()

            setTimeout(() => {
              this.$v.$reset()
            })
          } else {
            this.$popupRes({
              title: 'Failed!',
              message: res.data.message,
              variant: 'danger',
            })
          }
        })
    },
  },
  validations: {
    excelFile: {
      required,
    },
  },
}
</script>
